import { SESSION_KEY } from 'utils/constants';

export const getIsLoading = (state) => !!state.auth.loading;
export const getIsLoggedIn = () => !!localStorage.getItem(SESSION_KEY);
